import React, { useEffect, useState } from "react";
import WeeklyNewLetter from "./WeeklyNewLetter";
import axios from "axios";
import { apiToken, baseUrl } from "../../utils/base_url";
import { MarkdownComponent } from "../../layouts/FormLayout";
import { Link } from "react-router-dom";

const BlogListingFooter = () => {
  const [footerLinks, setFooterLinks] = useState();
  const [footerData, setFooterData] = useState();

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const res = await axios.get(`${baseUrl}/api/blog-footers`, {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        });
        console.log(res?.data?.data[0]);
        setFooterData(res?.data?.data[0]);
        setFooterLinks([
          res?.data?.data[0]?.quick_links,
          res?.data?.data[0]?.categories[0],
        ]);
      } catch (error) {
        console.log(error);
      }
    };

    fetchFooterData();
  }, []);

  return (
    <>
      <div
        className="container-fluid py-4 px-5"
        style={{ background: "#000000", border: "1px solid #242535" }}
      >
        <div className="row gy-5 py-3 blog-footer">
          <div className="col-12">
            <div className="row gx-5 gy-5 gy-md-0">
              <div className="col-md-4 text-white">
                {/* <div className="d-flex flex-column gap-3">
                  <span className="text-white fs18 fw-medium">About</span>
                  <p className=" fs18 fw-light" style={{ color: "#97989F" }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam
                  </p>
                </div>

                <div className="d-flex flex-column gap-1 mt-1">
                  {contacts?.map((data, idx) => (
                    <div key={idx} className="d-flex align-items-center gap-1">
                      <span className="text-white fs-6 fw-medium">
                        {data?.name} :
                      </span>
                      <span
                        className="fs-6 fw-medium"
                        style={{ color: "#97989F" }}
                      >
                        {data?.info}
                      </span>
                    </div>
                  ))}
                </div> */}
                <MarkdownComponent markdown={footerData?.about} />
              </div>

              {footerLinks?.map((data, idx) => (
                <div key={idx} className="col-md-2">
                  <div className="d-flex flex-column gap-4">
                    <span className="text-white fs18 fw-medium">
                      {data?.heading}
                    </span>

                    <div className="d-flex flex-column gap-1">
                      {data?.links?.map((info, id) => (
                        <Link
                          key={id}
                          to={`/${info?.link}`}
                          style={{ color: "#97989F" }}
                          className=" text-decoration-none "
                        >
                          {info?.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ))}

              <div className="col-md-4 px-0 px-md-4">
                <WeeklyNewLetter data={footerData?.newsletter} />
              </div>
            </div>
          </div>

          <div
            className="col-12 p-0"
            style={{ borderTop: "1px solid #242535" }}
          >
            <div className="d-flex align-items-center justify-content-md-between justify-content-center py-3 flex-wrap flex-md-nowrap gap-3 gap-md-0">
              <span className="fs-6 fw-light" style={{ color: "#BABABF" }}>
                {footerData?.copyright}
              </span>

              <div className="d-flex align-items-center gap-4 justify-content-md-end flex-wrap flex-md-nowrap justify-content-center">
                {footerData?.footer_links?.links?.map((linkData, idx) => (
                  <span
                    className="fs-6 fw-light cursor-pointer"
                    key={idx}
                    style={{ color: "#BABABF" }}
                  >
                    {linkData?.name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogListingFooter;
